import { render } from "./WarningAlert.vue?vue&type=template&id=40bae894"
import script from "./WarningAlert.vue?vue&type=script&lang=js"
export * from "./WarningAlert.vue?vue&type=script&lang=js"
script.render = render

export default script